import { FC } from "react";
import { Product } from "@prisma/client";

import ProductCard from "@components/common/product-card";
import ResponsiveSlider from "@components/common/responsive-slider";

interface Props {
  title: string;
  products: Product[];
}

const ProductSlider: FC<Props> = ({ title, products }) => {
  return products.length > 0 ? (
    <div className="flex flex-col w-full my-20">
      <h4 className="my-4 text-lg font-semibold pl-4 text-black">{title}</h4>
      <div className="overflow-hidden">
        <div>
          <ResponsiveSlider
            settings={{ className: "not-centered-slider" }}
            breakpoints={{
              xxl: 6,
              lg: 4,
              base: 2,
            }}
          >
            {products.map((product) => (
              <div key={product.id} className="px-3">
                <ProductCard {...product} />
              </div>
            ))}
          </ResponsiveSlider>
        </div>
      </div>
    </div>
  ) : null;
};

export default ProductSlider;
